import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './preferencesStyle.css';
import { Radio, Tab, Dropdown } from 'semantic-ui-react';
import localStore from 'store';

import { isEmpty } from 'lodash';

import { v1 as uuidv1 } from 'uuid';
import Rule from './Rule';
import preferenceZIndex from '../../../utilities/preferenceUtil';

class InnerRuleSet extends Component {
  static swapHandle(arr, idx1, idx2) {
    const newArr = arr;
    const temp = newArr[idx1];
    newArr[idx1] = newArr[idx2];
    newArr[idx2] = temp;
  }

  static findOuterRules(ruleId, ruleList) {
    return ruleList.filter(item => item.uid === ruleId).map(item => item.uid);
  }

  selectActionHandler = (e, action) => {
    const { refId, parentId, parentRender } = this.props;
    const preference = localStore.get('preference') || {};
    const { ruleSetList, ruleList, innerRuleSetList } = preference;

    let parent = ruleSetList.find(r => r.uid === parentId);
    if (isEmpty(parent)) {
      parent = innerRuleSetList.find(r => r.uid === parentId);
    }
    const parentItems = parent.items;
    const itemIndex = parentItems.indexOf(refId);
    const innerRuleSet = innerRuleSetList.find(
      irs => irs.uid === refId
    );

    e.preventDefault();

    switch (action.value) {
      case 'Add Rule': {
        const newRule = {
          uid: uuidv1(),
          ruleType: '',
          facts: [],
          operatorType: '',
          include: false,
        };

        ruleList.push(newRule);
        innerRuleSet.items.push(newRule.uid);

        localStore.set('preference', preference);
        parentRender();
        break;
      }
      case 'Add Inner Rule': {
        const newInnerRule = {
          uid: uuidv1(),
          ruleType: 'OR',
          items: [],
        };

        innerRuleSetList.push(newInnerRule);
        innerRuleSet.items.push(newInnerRule.uid);

        localStore.set('preference', preference);
        parentRender();
        break;
      }
      case 'Move Up':
        if (itemIndex > 0) {
          InnerRuleSet.swapHandle(parentItems, itemIndex, itemIndex - 1);
          localStore.set('preference', preference);
          parentRender();
        }
        break;
      case 'Move Down':
        if (itemIndex < parentItems.length - 1) {
          InnerRuleSet.swapHandle(parentItems, itemIndex, itemIndex + 1);
          localStore.set('preference', preference);
          parentRender();
        }
        break;
      case 'Delete InnerRule': {
        parent.items = parentItems.filter(item => item !== refId);
        const allRules = this.findAllRulesOfCurrent(
          refId,
          ruleList,
          innerRuleSetList
        );
        const allInnerRuleSet = this.findAllInnerRulesetOfCurrent(
          refId,
          innerRuleSetList
        );
        preference.innerRuleSetList = innerRuleSetList.filter(
          i => !allInnerRuleSet.includes(i.uid)
        );
        preference.ruleList = ruleList.filter(
          item => !allRules.includes(item.uid)
        );
        localStore.set('preference', preference);
        parentRender();
        break;
      }
      default:
        break;
    }
  };

  findAllInnerRulesetOfCurrent(refId, innerRuleSetList) {
    let results = [];
    innerRuleSetList.forEach(irs => {
      if (irs.uid === refId) {
        results.push(irs.uid);
        if (irs.items.length === 1) {
          results.push(irs.uid);
          return;
        }
        irs.items.forEach(element => {
          const nested = this.findAllInnerRulesetOfCurrent(element, innerRuleSetList);
          results = [...results, ...nested];
        });
      }
    });
    return results;
  }

  findAllRulesOfCurrent(refId, rulesList, innerRuleSetList) {
    const outerRules = InnerRuleSet.findOuterRules(refId, rulesList);
    const innerRules = this.findInnerRules(refId, rulesList, innerRuleSetList);
    return [...outerRules, ...innerRules];
  }

  findInnerRules(refId, ruleList, innerRuleSet) {
    let results = [];
    innerRuleSet.forEach(irs => {
      let rl = InnerRuleSet.findOuterRules(refId, ruleList);
      if (irs.uid === refId && rl.length > 0) {
        results = [...results, refId];
        return;
      }
      if (irs.uid === refId && irs.items.length > 0 && rl.length === 0) {
        irs.items.forEach(element => {
          rl = InnerRuleSet.findOuterRules(element, ruleList);
          const orl = rl;
          if (orl.length > 0) {
            results = [...results, ...orl];
            return;
          }
          const nested = this.findInnerRules(element, ruleList, innerRuleSet);
          results = [...results, ...nested];
        });
      }
    });
    return results;
  }

  onCheckRadioOption = (e, data) => {
    const { refId, parentRender } = this.props;
    const preference = localStore.get('preference') || {};
    const { innerRuleSetList } = preference;

    const innerRuleSet = innerRuleSetList.find(
      irs => irs.uid === refId
    );

    innerRuleSet.ruleType = data.value;
    localStore.set('preference', preference);
    parentRender();
  };

  render() {
    const {
      refId,
      deep,
      first,
      last,
      ruleSetGroupIndex,
      innerRuleSetGroupIndex,
      isSubmitting,
    } = this.props;

    const preference = localStore.get('preference') || {};
    const { ruleList, innerRuleSetList } = preference;

    const innerRuleSet = innerRuleSetList ? innerRuleSetList.find(
      irs => irs.uid === refId
    ) : null;

    const innerRuleSetItems = isEmpty(innerRuleSet) ? [] : innerRuleSet.items;

    const items = isEmpty(innerRuleSetItems)
      ? []
      : innerRuleSetItems.map((item, idx) => {
        const ruleItems = ruleList.filter(rule => rule.uid === item);

        if (!isEmpty(ruleItems)) {
          return (
            <Rule
              key={item}
              refId={item}
              parentId={refId}
              parentRender={() => {
                this.setState({});
              }}
              first={idx === 0}
              last={idx === innerRuleSetItems.length - 1}
              isSubmitting={isSubmitting}
            />
          );
        }

        const irs = innerRuleSetList.filter(
          innerRule => innerRule.uid === item
        );
        if (!isEmpty(irs)) {
          return (
            <InnerRuleSet
              key={item}
              refId={item}
              deep={deep + 1}
              parentId={refId}
              parentRender={() => {
                this.setState({});
              }}
              ruleSetGroupIndex={`${ruleSetGroupIndex}${innerRuleSetGroupIndex}.`}
              innerRuleSetGroupIndex={idx + 1}
              first={idx === 0}
              last={idx === innerRuleSetItems.length - 1}
              isSubmitting={isSubmitting}
            />
          );
        }
        return null;
      });

    const RULE_ACTIONS = [
      { key: 1, text: 'Add Rule', value: 'Add Rule' },
      {
        key: 2,
        text: 'Add Inner Rule',
        value: 'Add Inner Rule',
        disabled: deep === 5,
      },
      {
        key: 3, text: 'Move Up', value: 'Move Up', disabled: first,
      },
      {
        key: 4, text: 'Move Down', value: 'Move Down', disabled: last,
      },
      { key: 'Delete InnerRule', text: 'Delete', value: 'Delete InnerRule' },
    ];

    const panes = [
      {
        menuItem: `Inner Rule ${ruleSetGroupIndex}${innerRuleSetGroupIndex}`,
        render: () => (
          <Tab.Pane style={{ background: '#F3F3F3' }} key={refId}>
            {' '}
            <section>
              <div
                className='ruleSetHeaderAction'
                style={{ zIndex: `${100000 - preferenceZIndex(refId)}` }}
              >
                <span />
                <span>
                  <Dropdown
                    style={{ width: '200px' }}
                    fluid
                    selection
                    text='Actions'
                    options={RULE_ACTIONS}
                    selectOnBlur={false}
                    value={null}
                    onChange={this.selectActionHandler}
                  />
                </span>
              </div>
              <div style={{ textAlign: 'right', marginBottom: '30px' }}>
                <Radio
                  label='OR'
                  name={`ruleType${refId}`}
                  value='OR'
                  checked={innerRuleSet && innerRuleSet.ruleType === 'OR'}
                  style={{ paddingRight: '15px' }}
                  onChange={this.onCheckRadioOption}
                />
                <Radio
                  label='AND'
                  name={`ruleType${refId}`}
                  value='AND'
                  checked={innerRuleSet && innerRuleSet.ruleType === 'AND'}
                  onChange={this.onCheckRadioOption}
                />
              </div>

              {isEmpty(items) ? '' : items}
            </section>
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div className='mb30px'>
        <Tab
          panes={panes}
          style={{ width: '100%' }}
          className='tabInnerRuleSet'
        />
      </div>
    );
  }
}

InnerRuleSet.propTypes = {
  refId: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  parentRender: PropTypes.func.isRequired,
  deep: PropTypes.number,
  first: PropTypes.bool,
  last: PropTypes.bool,
  ruleSetGroupIndex: PropTypes.string,
  innerRuleSetGroupIndex: PropTypes.number,
  isSubmitting: PropTypes.bool,
};

InnerRuleSet.defaultProps = {
  deep: 0,
  first: false,
  last: false,
  ruleSetGroupIndex: '',
  innerRuleSetGroupIndex: 0,
  isSubmitting: false,
};

export default InnerRuleSet;
